import React, { useEffect } from "react";
import "./card.result.css";
import { upperCase } from "lodash";
import { config } from "../../../../services/config";
// import pic from "../../../../../public/media/logos/girl-image.jpg";

// const pic = "../../../../../public/media/logos/girl-image.jpg";
// const logo =
// "https://darearqam.com/wp-content/uploads/2020/03/daraarqam-logo.jpg";

function ResultCardJAD({
  studentResultList,
  studentFinalResult,
  studentDetails,
  campusDetail,
  student_result_overall,
  isInclude,
  currentExam,
  icon,
  unitName,
  weekList,
  studentResultGradeWise,
  gradeData,
}) {
  useEffect(() => {
    if (Array.isArray(student_result_overall)) {
      const filtered = student_result_overall.filter(
        (item) => item.exam == "FIRST TERM",
      );
      student_result_overall = filtered;
    }
    console.log(student_result_overall);
  }, [student_result_overall]);

  const getTotalNumber = (array) => {
    let sum = 0;

    array.forEach((element) => {
      sum += parseInt(element.gain_marks);
    });

    return sum;
  };

  const getPracticalTotalNumber = (array) => {
    console.log("getPracticalTotalNumber", array);
    let sum = 0;

    array.forEach((element) => {
      sum += parseInt(element.practical_marks);
    });

    return sum;
  };

  const getRange = (max_marks, min_marks) => {
    let obtainMarks = min_marks / max_marks;
    let middle = obtainMarks * 100;
    let percentage = middle.toFixed(2);

    if (percentage <= 100 && percentage >= 90) {
      return "90% and above";
    } else if (percentage < 90 && percentage >= 80) {
      return "80% – 89.99%";
    } else if (percentage < 80 && percentage >= 70) {
      return "70% – 79.99%";
    } else if (percentage < 70 && percentage >= 60) {
      return "60% – 69.99%";
    } else if (percentage < 60 && percentage >= 50) {
      return "50% – 59.99%";
    } else if (percentage < 50 && percentage >= 0) {
      return "Below 50%";
    } else {
      return "--";
    }
  };

  const getPercentage = (totalmarks, gainMarks) => {
    const percentage = (gainMarks / totalmarks) * 100;
    return percentage.toFixed(1) + "%";
  };

  const getMonthName = (date) => {
    const monthNames = [
      "January", // index 0
      "February", // index 1
      "March", // index 2
      "April", // index 3
      "May", // index 4
      "June", // index 5
      "July", // index 6
      "August", // index 7
      "September", // index 8
      "October", // index 9
      "November", // index 10
      "December", // index 11
    ];
    const d = new Date(date);

    return upperCase(`${monthNames[d.getMonth()]}, ${d.getFullYear()}`);
  };

  // Function to get the name by week_id
  const getWeekNameById = (week_id) => {
    const week = weekList.find((w) => w.id == week_id);
    return week ? week.name : "Unknown Week"; // Return name or a default value
  };

  return (
    <table style={{ margin: "0 auto" }}>
      <tbody>
        <tr>
          <td>
            <table
              className="result__card__table"
              border="2"
              cellpadding="0"
              cellspacing="0"
              width="100%"
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      width: "118px",
                      textAlign: "center",
                      padding: "1rem",
                    }}
                  >
                    <img
                      className="p-1"
                      id="Image1"
                      src={icon}
                      width="100%"
                      alt="Logo"
                    />
                  </td>
                  <td
                    style={{
                      width: "100%",
                      textAlignLast: "center",
                      padding: "1rem",
                    }}
                  >
                    <span id="LblOIDName" className="AName">
                      {unitName}
                    </span>
                    <br />
                    <span id="LblTermName" className="AName1">
                      {campusDetail?.exam?.exam_type?.name}
                      {campusDetail?.exam?.week_id != null
                        ? campusDetail?.exam?.month != null
                          ? " " +
                            "( " +
                            getWeekNameById(campusDetail?.exam?.week_id) +
                            " OF " +
                            getMonthName(campusDetail?.exam?.month) +
                            " )"
                          : " " +
                            "( " +
                            getWeekNameById(campusDetail?.exam?.week_id) + // Use the week name only
                            " )"
                        : campusDetail?.exam?.month != null
                        ? " " +
                          "( " +
                          getMonthName(campusDetail?.exam?.month) +
                          " )"
                        : ""}
                    </span>
                    <br />
                    <span id="LblTermName" className="AName2">
                      MARK SHEET
                    </span>
                  </td>
                  <td
                    style={{
                      width: "125px",
                      textAlign: "center",
                      padding: "1rem",
                    }}
                  >
                    <img
                      id="StudentImage"
                      src={
                        studentDetails?.picture != null
                          ? studentDetails?.picture
                          : "/media/users/blank.png"
                      }
                      style={{ height: 135, width: 124, marginRight: 15 }}
                      alt="Student"
                    />
                  </td>
                </tr>
                <br />
                <>
                  {/* <tr>
                    <td colSpan="2">
                      <table
                        border="0"
                        cellpadding="5"
                        cellspacing="0"
                        width="100%"
                      >
                        <tbody>
                          <tr>
                            <td
                              className="BoldText"
                              style={{
                                width: "145px",
                                textAlign: "right",
                              }}
                            >
                              Admission ID :-
                            </td>
                            <td
                              style={{
                                width: "330px",
                                textAlign: "start",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblAdmissionID" className="BoldText">
                                {studentDetails?.admission_id}
                              </span>
                            </td>
                            <td
                              className="LabelStyle"
                              style={{
                                width: "90px",
                                textAlign: "right",
                              }}
                            >
                              Session :-
                            </td>
                            <td
                              align="Center"
                              style={{
                                width: "135px",
                                textAlign: "left",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblSession" className="NormalText">
                                {campusDetail?.exam?.session?.year}{" "}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr> */}
                  <tr>
                    <td colSpan="3">
                      <table
                        border="1"
                        cellPadding="5"
                        cellSpacing="0"
                        width="100%"
                      >
                        <tbody>
                          <tr>
                            <td
                              className="BoldText"
                              style={{
                                width: "125px",
                                border: "1px solid black",
                              }}
                            >
                              <b>Name :-</b>
                            </td>
                            <td
                              style={{
                                width: "240px",
                                border: "1px solid black",
                                textAlign: "start",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblClass" className="NormalText">
                                {studentDetails?.name}{" "}
                              </span>
                            </td>
                            <td
                              className="LabelStyle"
                              style={{
                                width: "80px",
                                border: "1px solid black",
                              }}
                            >
                              <b>Father's Name :-</b>
                            </td>
                            <td
                              align="Center"
                              style={{
                                width: "255px",
                                border: "1px solid black",
                                textAlign: "start",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblSection" className="NormalText">
                                {studentDetails?.father_name}{" "}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="BoldText"
                              style={{
                                width: "125px",
                                border: "1px solid black",
                              }}
                            >
                              <b>Class :-</b>
                            </td>
                            <td
                              style={{
                                width: "240px",
                                border: "1px solid black",
                                textAlign: "start",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblClass" className="NormalText">
                                {campusDetail?.student_class?.name ??
                                  studentResultList[0]?.student_class
                                    ?.name}{" "}
                              </span>
                            </td>
                            <td
                              className="LabelStyle"
                              style={{
                                width: "80px",
                                border: "1px solid black",
                              }}
                            >
                              <b>Section :-</b>
                            </td>
                            <td
                              align="Center"
                              style={{
                                width: "255px",
                                border: "1px solid black",
                                textAlign: "start",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblSection" className="NormalText">
                                {campusDetail?.global_section?.name ??
                                  studentResultList[0]?.global_section?.name}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="BoldText"
                              style={{
                                width: "125px",
                                border: "1px solid black",
                              }}
                            >
                              <b>Admission ID :-</b>
                            </td>
                            <td
                              style={{
                                width: "240px",
                                border: "1px solid black",
                                textAlign: "start",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblClass" className="NormalText">
                                {studentDetails?.admission_id}
                              </span>
                            </td>
                            <td
                              className="LabelStyle"
                              style={{
                                width: "80px",
                                border: "1px solid black",
                              }}
                            >
                              <b>Session :-</b>
                            </td>
                            <td
                              align="Center"
                              style={{
                                width: "255px",
                                border: "1px solid black",
                                textAlign: "start",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblSection" className="NormalText">
                                {campusDetail?.exam?.session?.year}{" "}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              style={{
                                textAlign: "start",
                                paddingTop: "2rem",
                              }}
                            ></td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <table
                                border="0"
                                cellPadding="0"
                                cellSpacing="0"
                                width="100%"
                              >
                                <tbody>
                                  <tr>
                                    <td>
                                      <div>
                                        <table
                                          className="GridStyleResultCard"
                                          cellSpacing="0"
                                          rules="all"
                                          border="2"
                                          id="GridView1"
                                          style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                          }}
                                        >
                                          <tbody>
                                            <tr
                                              className="GridHeaderStyle"
                                              style={{
                                                border: "1px solid black",
                                              }}
                                            >
                                              <th
                                                colSpan={2}
                                                style={{
                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                SUBJECTS
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  width: "110px",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Total Marks
                                              </th>
                                              {/* <th
                                                style={{
                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Theory
                                              </th> 
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Presentation
                                              </th> */}
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Total Gain
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                %
                                              </th>
                                              <th
                                                style={{
                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Grade
                                              </th>
                                              {/* <th
                                                style={{
                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Remarks
                                              </th> */}
                                            </tr>

                                            {studentResultList &&
                                              studentResultList.map(
                                                (onePersonResult, index) => (
                                                  <React.Fragment key={index}>
                                                    {/* Special Subject */}
                                                    {onePersonResult?.subject
                                                      ?.is_partial == "1" ? (
                                                      <React.Fragment>
                                                        <tr className="GridRowStyle">
                                                          <td
                                                            rowSpan={2}
                                                            // valign="middle"
                                                            style={{
                                                              border:
                                                                "1px solid black",
                                                              textAlign:
                                                                "start",
                                                              color: `${config.txtColor}`,
                                                              paddingLeft:
                                                                "10px",
                                                              width: "150px",
                                                            }}
                                                          >
                                                            {
                                                              onePersonResult
                                                                ?.subject?.name
                                                            }
                                                          </td>
                                                          {/* Sub Subject */}
                                                          <td
                                                            style={{
                                                              border:
                                                                "1px solid black",
                                                              width: "150px",
                                                            }}
                                                          >
                                                            Reading & Writing
                                                          </td>
                                                          <td
                                                            align="center"
                                                            // valign="middle"
                                                            style={{
                                                              width: "90px",
                                                              border:
                                                                "1px solid black",
                                                              textAlign:
                                                                "center",
                                                              color: `${config.txtColor}`,
                                                            }}
                                                          >
                                                            {
                                                              onePersonResult?.full_marks_rw
                                                            }
                                                          </td>
                                                          <td
                                                            align="center"
                                                            // valign="middle"
                                                            style={{
                                                              width: "90px",
                                                              border:
                                                                "1px solid black",
                                                              textAlign:
                                                                "center",
                                                              color: `${config.txtColor}`,
                                                            }}
                                                          >
                                                            {
                                                              onePersonResult?.gain_marks_rw
                                                            }
                                                          </td>
                                                          <td
                                                            align="center"
                                                            // valign="middle"
                                                            style={{
                                                              width: "90px",
                                                              border:
                                                                "1px solid black",
                                                              textAlign:
                                                                "center",
                                                              color: `${config.txtColor}`,
                                                            }}
                                                          >
                                                            {
                                                              onePersonResult?.percentage_rw
                                                            }
                                                          </td>
                                                          <td
                                                            rowSpan={2}
                                                            align="center"
                                                            // valign="middle"
                                                            style={{
                                                              width: "90px",
                                                              border:
                                                                "1px solid black",
                                                              textAlign:
                                                                "center",
                                                              color: `${config.txtColor}`,
                                                            }}
                                                          >
                                                            {
                                                              onePersonResult?.grade
                                                            }
                                                          </td>
                                                        </tr>
                                                        <tr className="GridRowStyle">
                                                          {/* Sub Subject */}
                                                          <td
                                                            style={{
                                                              border:
                                                                "1px solid black",
                                                              width: "200px",
                                                            }}
                                                          >
                                                            Speaking & Listening
                                                          </td>
                                                          <td
                                                            align="center"
                                                            // valign="middle"
                                                            style={{
                                                              width: "90px",
                                                              border:
                                                                "1px solid black",
                                                              textAlign:
                                                                "center",
                                                              color: `${config.txtColor}`,
                                                            }}
                                                          >
                                                            {
                                                              onePersonResult?.full_marks_sl
                                                            }
                                                          </td>
                                                          <td
                                                            align="center"
                                                            // valign="middle"
                                                            style={{
                                                              width: "90px",
                                                              border:
                                                                "1px solid black",
                                                              textAlign:
                                                                "center",
                                                              color: `${config.txtColor}`,
                                                            }}
                                                          >
                                                            {
                                                              onePersonResult?.gain_marks_sl
                                                            }
                                                          </td>
                                                          <td
                                                            align="center"
                                                            // valign="middle"
                                                            style={{
                                                              width: "90px",
                                                              border:
                                                                "1px solid black",
                                                              textAlign:
                                                                "center",
                                                              color: `${config.txtColor}`,
                                                            }}
                                                          >
                                                            {
                                                              onePersonResult?.percentage_sl
                                                            }
                                                          </td>
                                                        </tr>
                                                      </React.Fragment>
                                                    ) : (
                                                      <tr className="GridRowStyle">
                                                        <td
                                                          colSpan={2}
                                                          style={{
                                                            width: "300px",
                                                            border:
                                                              "1px solid black",
                                                            textAlign: "start",
                                                            color: `${config.txtColor}`,
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          {
                                                            onePersonResult
                                                              ?.subject?.name
                                                          }{" "}
                                                        </td>
                                                        <td
                                                          align="center"
                                                          style={{
                                                            width: "90px",
                                                            border:
                                                              "1px solid black",
                                                            textAlign: "center",
                                                            color: `${config.txtColor}`,
                                                          }}
                                                        >
                                                          {
                                                            onePersonResult?.full_marks
                                                          }
                                                        </td>
                                                        {/* <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        width: "90px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {onePersonResult.status ==
                                                      "Present"
                                                        ? onePersonResult.gain_marks
                                                        : onePersonResult.status}
                                                    </td> 
                                                    <td
                                                      style={{
                                                        width: "90px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {onePersonResult?.practical_marks ==
                                                      0
                                                        ? "--"
                                                        : onePersonResult?.practical_marks}
                                                    </td> */}
                                                        <td
                                                          align="center"
                                                          // valign="middle"
                                                          style={{
                                                            width: "90px",
                                                            border:
                                                              "1px solid black",
                                                            textAlign: "center",
                                                            color: `${config.txtColor}`,
                                                          }}
                                                        >
                                                          {Number(
                                                            onePersonResult.gain_marks,
                                                          ) +
                                                            Number(
                                                              onePersonResult?.practical_marks,
                                                            )}
                                                        </td>
                                                        <td
                                                          align="center"
                                                          // valign="middle"
                                                          style={{
                                                            width: "90px",
                                                            border:
                                                              "1px solid black",
                                                            textAlign: "center",
                                                            color: `${config.txtColor}`,
                                                          }}
                                                        >
                                                          {
                                                            onePersonResult?.percentage
                                                          }
                                                          %
                                                        </td>
                                                        <td
                                                          align="center"
                                                          // valign="middle"
                                                          style={{
                                                            width: "90px",
                                                            border:
                                                              "1px solid black",
                                                            textAlign: "center",
                                                            color: `${config.txtColor}`,
                                                          }}
                                                        >
                                                          {
                                                            onePersonResult?.grade
                                                          }
                                                        </td>
                                                        {/* <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        width: "90px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {onePersonResult?.grade ==
                                                        "F" ||
                                                      onePersonResult?.grade ==
                                                        "F+"
                                                        ? "FAIL"
                                                        : "PASS"}
                                                    </td> */}
                                                      </tr>
                                                    )}
                                                  </React.Fragment>
                                                ),
                                              )}

                                            <tr className="GridRowStyle">
                                              <td
                                                colSpan={2}
                                                // valign="middle"
                                                style={{
                                                  width: "300px",
                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                  fontWeight: "bold",
                                                  textAlign: "start",
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                OVER ALL RESULT
                                              </td>
                                              <td
                                                align="center"
                                                // valign="middle"
                                                style={{
                                                  width: "90px",
                                                  border: "1px solid black",
                                                  textAlign: "center",
                                                  fontWeight: "bold",
                                                  color: `${config.txtColor}`,
                                                }}
                                              >
                                                {
                                                  student_result_overall?.total_full_marks
                                                }
                                              </td>
                                              {/* <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        width: "90px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {onePersonResult.status ==
                                                      "Present"
                                                        ? onePersonResult.gain_marks
                                                        : onePersonResult.status}
                                                    </td> 
                                                    <td
                                                      style={{
                                                        width: "90px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {onePersonResult?.practical_marks ==
                                                      0
                                                        ? "--"
                                                        : onePersonResult?.practical_marks}
                                                    </td> */}
                                              <td
                                                align="center"
                                                // valign="middle"
                                                style={{
                                                  width: "90px",
                                                  border: "1px solid black",
                                                  textAlign: "center",
                                                  fontWeight: "bold",
                                                  color: `${config.txtColor}`,
                                                }}
                                              >
                                                {
                                                  student_result_overall?.total_gain_marks
                                                }
                                              </td>
                                              <td
                                                align="center"
                                                // valign="middle"
                                                style={{
                                                  width: "90px",
                                                  border: "1px solid black",
                                                  textAlign: "center",
                                                  fontWeight: "bold",
                                                  color: `${config.txtColor}`,
                                                }}
                                              >
                                                {
                                                  student_result_overall?.percentage
                                                }
                                              </td>
                                              <td
                                                align="center"
                                                // valign="middle"
                                                style={{
                                                  width: "90px",
                                                  border: "1px solid black",
                                                  textAlign: "center",
                                                  fontWeight: "bold",
                                                  color: `${config.txtColor}`,
                                                }}
                                              >
                                                {student_result_overall?.grade}
                                              </td>
                                              {/* <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        width: "90px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {onePersonResult?.grade ==
                                                        "F" ||
                                                      onePersonResult?.grade ==
                                                        "F+"
                                                        ? "FAIL"
                                                        : "PASS"}
                                                    </td> */}
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  {/* <tr>
                    <td colSpan="3" align="center">
                      <div
                        style={{
                          borderRight: "1px solid black",
                          borderTop: "1px solid black",
                          borderLeft: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        <table
                          id="TblFail"
                          border="0"
                          cellPadding="0"
                          cellSpacing="0"
                          width="100%"
                        >
                          <tbody>
                            <tr>
                              <td
                                className="BoldText"
                                style={{
                                  width: "360px",
                                  color: `${config.txtColor}`,
                                  fontWeight: "bold",
                                }}
                              >
                                OVER ALL RESULT
                              </td>
                              <td
                                style={{
                                  width: "130px",
                                  color: `${config.txtColor}`,
                                }}
                              >
                                {student_result_overall?.full_marks}
                              </td>

                              <td
                                style={{
                                  width: "110px",
                                  color: `${config.txtColor}`,
                                }}
                              >
                                {student_result_overall?.gain_marks}
                              </td>

                              {student_result_overall?.fail_in.length > 0 ? (
                                <>
                                  <td
                                    style={{
                                      color: `${config.txtColor}`,
                                      fontWeight: "bold",
                                      width: "325px",
                                    }}
                                  >
                                    {student_result_overall?.fail_in.length > 0
                                      ? "Failed In"
                                      : ""}
                                    &nbsp;&nbsp;
                                    {student_result_overall?.fail_in.length > 0
                                      ? student_result_overall?.fail_in.map(
                                          (overvall, i) => (
                                            <span
                                              style={{
                                                color: `${config.txtColor}`,
                                                alignSelf: "flex-end",
                                              }}
                                              key={i + 1}
                                              id="LblGazres"
                                              className="BoldText"
                                            >
                                              {overvall.substr(0, 3)}
                                              {","}&nbsp;
                                            </span>
                                          ),
                                        )
                                      : null}
                                  </td>
                                </>
                              ) : ( 
                                <> 
                              <td
                                style={{
                                  width: "105px",
                                  color: `${config.txtColor}`,
                                }}
                              >
                                {student_result_overall?.percentage}
                              </td>
                              <td
                                id="forgrade"
                                style={{
                                  width: "110px",
                                  color: `${config.txtColor}`,
                                }}
                              >
                                {student_result_overall?.grade}
                              </td>
                               <td
                                    style={{
                                      paddingRight: "5px",
                                      width: "110px",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {student_result_overall?.remarks}
                                  </td> 
                               </>
                               )} 
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr> */}

                  <tr>
                    <td colSpan="3" style={{ textAlign: "left" }}>
                      <br />
                      <table
                        border="0"
                        cellPadding="8"
                        cellSpacing="0"
                        width="100%"
                      >
                        <tbody>
                          <tr className="d-flex justify-content-center">
                            <td style={{ verticalAlign: "top" }}>
                              <table
                                id="DataList1"
                                className="NormalText"
                                cellSpacing="0"
                                style={{ borderCollapse: "collapse" }}
                              >
                                <thead>
                                  <tr className="border-1">
                                    <th
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "end",
                                        width: "150px",
                                      }}
                                    >
                                      <b>Percentage Range</b>
                                    </th>
                                    <th
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                        width: "100px",
                                      }}
                                    >
                                      <b>Grade</b>
                                    </th>
                                    <th
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "start",
                                        width: "250px",
                                      }}
                                    >
                                      <b>Achivement Level</b>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {gradeData.map((level, index) => (
                                    <tr className="border-1" key={index}>
                                      <td
                                        style={{
                                          color: `${config.txtColor}`,
                                          textAlign: "end",
                                        }}
                                      >
                                        {getRange(
                                          level.max_marks,
                                          level.min_marks,
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          color: `${config.txtColor}`,
                                          textAlign: "center",
                                        }}
                                      >
                                        {level.grade}
                                      </td>
                                      <td
                                        style={{
                                          color: `${config.txtColor}`,
                                          textAlign: "start",
                                        }}
                                      >
                                        {level.level}
                                      </td>
                                    </tr>
                                  ))}
                                  {/* <tr className="border-1">
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "end",
                                      }}
                                    >
                                      90% - Above
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                      }}
                                    >
                                      EX
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "start",
                                      }}
                                    >
                                      Exceeding
                                    </td>
                                  </tr>
                                  <tr className="border-1">
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "end",
                                      }}
                                    >
                                      80% - 89.99%
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                      }}
                                    >
                                      AC
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "start",
                                      }}
                                    >
                                      Accomplishing
                                    </td>
                                  </tr>
                                  <tr className="border-1">
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "end",
                                      }}
                                    >
                                      70% - 79.99%
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                      }}
                                    >
                                      DV
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "start",
                                      }}
                                    >
                                      Developing
                                    </td>
                                  </tr>
                                  <tr className="border-1">
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "end",
                                      }}
                                    >
                                      60% - 69.99%
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                      }}
                                    >
                                      BG
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "start",
                                      }}
                                    >
                                      Beginning
                                    </td>
                                  </tr>
                                  <tr className="border-1">
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "end",
                                      }}
                                    >
                                      50% - 59.99%
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                      }}
                                    >
                                      LE
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "start",
                                      }}
                                    >
                                      Limited Evidence
                                    </td>
                                  </tr>
                                  <tr className="border-1">
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "end",
                                      }}
                                    >
                                      Below 50%
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                      }}
                                    >
                                      NS
                                    </td>
                                    <td
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "start",
                                      }}
                                    >
                                      Not Sufficient - Support Required
                                    </td>
                                  </tr> */}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="3" style={{ textAlign: "left" }}>
                      <br />
                      <table
                        border="0"
                        cellPadding="8"
                        cellSpacing="0"
                        width="100%"
                      >
                        <tbody>
                          <tr className="d-flex justify-content-center">
                            <td style={{ verticalAlign: "top" }}>
                              <table
                                id="DataList1"
                                className="NormalText"
                                cellSpacing="0"
                                style={{ borderCollapse: "collapse" }}
                              >
                                <thead>
                                  <tr className="border-1">
                                    <th
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                        width: "100px",
                                      }}
                                    >
                                      <b>Grade</b>
                                    </th>
                                    <th
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                        width: "150px",
                                      }}
                                    >
                                      <b>Achivement Level</b>
                                    </th>
                                    <th
                                      style={{
                                        color: `${config.txtColor}`,
                                        textAlign: "center",
                                        width: "750px",
                                      }}
                                    >
                                      <b>Description</b>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {gradeData.map((level, index) => (
                                    <tr className="border-1" key={index}>
                                      <td
                                        style={{
                                          color: `${config.txtColor}`,
                                          textAlign: "center",
                                        }}
                                      >
                                        {level.grade}
                                      </td>
                                      <td
                                        style={{
                                          color: `${config.txtColor}`,
                                          textAlign: "center",
                                        }}
                                      >
                                        {level.level}
                                      </td>
                                      <td
                                        style={{
                                          color: `${config.txtColor}`,
                                          textAlign: "start",
                                        }}
                                      >
                                        {level.description}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        textAlign: "Center",
                        width: "300px",
                        paddingLeft: "4rem",
                        color: `${config.txtColor}`,
                      }}
                      className="BoldText"
                    >
                      <br />
                      <br />
                      <br />
                      _____________________
                      <br />
                      Teacher's Signature
                    </td>
                    <td
                      style={{
                        textAlign: "Right",
                        color: `${config.txtColor}`,
                        width: "300px",
                      }}
                      className="BoldText"
                    ></td>
                    <td
                      style={{
                        textAlign: "Center",
                        color: `${config.txtColor}`,
                        width: "300px",
                        paddingRight: "4rem",
                      }}
                      className="BoldText"
                    >
                      <br />
                      <br />
                      <br />
                      _____________________
                      <br />
                      Principal's Signature
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3">
                      <div style={{ borderBottom: "1px solid black" }}>
                        <br />
                      </div>
                    </td>
                  </tr>
                </>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default ResultCardJAD;
